import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Sprite from '~components/Sprite'

class RoundedIcon extends Component {
  render () {
    return (
      <span className={classNames('border-coral border-2 rounded-1/2 icon icon-fill block items-center justify-center overflow-hidden p-0.5', this.props.className)} aria-hidden="true">
        <span className={classNames(
          'block group-hover:bg-coral group-hover:fill-white group-focus:fill-white group-focus:bg-coral rounded-1/2 transition-colors duration-150 ease-in-out',
          { 'bg-coral fill-white': this.props.active }
        )}
        >
          <Sprite name={this.props.name} />
        </span>
      </span>
    )
  }
}

RoundedIcon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.any,
  active: PropTypes.bool
}

export default RoundedIcon
